import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { HeadingItem, QuantityAdjuster, ReturnStickerSelection } from 'components';
import { TripContext } from "contexts";
import { SelectBox } from 'devextreme-react';
import { SecondaryPopUpField } from 'enums';
import React, { FC, Fragment, useContext } from 'react';
import { useReturnItemService } from 'services';
import { LineItem, ReturnChangeReason, ReturnItem } from 'services/types';
import { IconOptions } from "types";
import './returnitem-quantity-card.scss';

type Props = {
    isReturnStickerAvailable: boolean
    returnItem: ReturnItem,
    selectedReason: ReturnChangeReason,
    quantity: number,
    onQuantityAdjusted: (id: string | number, quantity: number) => void,
    onValueChanged: (returnStickerOption: SecondaryPopUpField, value: string | number | null) => void,
    onValueReasonChanged: (e: any) => void
}

export const ReturnItemQuantityCard: FC<Props> = ({ isReturnStickerAvailable, returnItem, selectedReason, quantity, onQuantityAdjusted, onValueChanged, onValueReasonChanged }) => {

    const tripContext = useContext(TripContext)
    const { isReturnItemCompleted, isReturnStickerDuplicate } = useReturnItemService();

    const lineItem: LineItem = tripContext.lineItems.find(item => item.id === returnItem.lineItemId) ?? {} as LineItem
    const returnChangeReasons: ReturnChangeReason[] = tripContext.returnChangeReasons.toArray() ?? []

    let headerIcon = (): IconOptions => {
        let icon: IconOptions = {} as IconOptions;
        icon = isReturnItemCompleted(returnItem) ? { icon: faCheckCircle, color: '#76AB21', size: '2x' }
            : { icon: faTimesCircle, color: '#EB5757', size: '2x' }

        return icon
    }

    return (
        <div className={'card-material'}>
            <HeadingItem text={`Counted Quantity`} rightHandIcon={headerIcon()} />
            <div className={'returnitem-qty-adjust-details'}>
                <div>Return Qty: {returnItem.returnQuantity}</div>
                <div>UOM: {lineItem.unitOfMeasure ?? 'N/A'}</div>
            </div>
            <QuantityAdjuster
                quantity={quantity}
                id={returnItem.id}
                onQuantityAdjusted={onQuantityAdjusted}
            />
            {returnItem.countedQuantity != null &&
                <Fragment>
                    {returnItem.countedQuantity != returnItem.returnQuantity &&
                        <div className={'secondary-popup-field'}>
                            <SelectBox
                                placeholder={'Select reason for change'}
                                items={returnChangeReasons}
                                displayExpr={'description'}
                                itemRender={(itemData: ReturnChangeReason) => <div className={'reconcile-selectionbox'}>{itemData.description}</div>}
                                value={selectedReason}
                                onValueChanged={e => e.value && onValueReasonChanged(e.value)}
                            >
                            </SelectBox>
                        </div>
                    }
                    {returnItem.countedQuantity > 0 &&
                        <div className={'secondary-popup-field'}>
                            <ReturnStickerSelection
                                isReturnStickerAvailable={isReturnStickerAvailable}
                                returnSticker={returnItem.returnSticker}
                                isReturnStickerDuplicate={isReturnStickerDuplicate(returnItem.returnSticker, returnItem.id, null, null, null)}        
                                noReturnStickerReason={returnItem.reasonForNoSticker}
                                onReturnStickerChanged={(value) => onValueChanged(SecondaryPopUpField.ReturnSticker, value)}
                                onNoReturnStickerReasonChanged={(value) => onValueChanged(SecondaryPopUpField.NoReturnSticker, value)}
                                handleRadioChecked={(value: any) => value == "Yes" ? onValueChanged(SecondaryPopUpField.ReturnSticker, 0) :
                                    onValueChanged(SecondaryPopUpField.NoReturnSticker, "")}
                            ></ReturnStickerSelection>
                        </div>
                    }
                </Fragment>
            }
        </div>
    )
}
